import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body text-center" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-5" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "bg-navy bg-opacity-15 rounded-circle badge text-black fs-5 fw-normal text-center" }
const _hoisted_5 = { class: "fs-2 mb-5" }
const _hoisted_6 = { class: "text-black-50 fs-8" }
const _hoisted_7 = { class: "btn btn-sm btn-navy d-flex justify-content-between align-items-center rounded-pill" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right-short fs-2x p-0" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "card mb-4 border border-4 border-navy border-opacity-10 h-100 rounded-4",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: "bg-navy bg-opacity-15 rounded-pill py-1 px-4 fw-bolder fs-8 text-navy",
          innerHTML: `${_ctx.item.acronym}`
        }, null, 8, _hoisted_3),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.item.quantity), 1)
      ]),
      (_ctx.item?.icon != null)
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: ['fas', _ctx.item.icon],
            size: "3x",
            class: "rounded bg-navy bg-opacity-10 border-white text-navy p-3 mb-5"
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.item.name), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.t('sportSubtitle')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.t('complete')) + " ", 1),
        _hoisted_8
      ])
    ])
  ]))
}